//#region src/starbucks_order_type.ts
var StarbucksOrderType = /* @__PURE__ */ function(StarbucksOrderType) {
	StarbucksOrderType["InStore"] = "in-store";
	StarbucksOrderType["DriveThru"] = "drive-thru";
	StarbucksOrderType["Curbside"] = "curbside";
	StarbucksOrderType["Outdoor"] = "outdoor";
	return StarbucksOrderType;
}(StarbucksOrderType || {});
//#endregion
export { StarbucksOrderType };

//# sourceMappingURL=starbucks_order_type.js.map